import {createSelector} from 'reselect'
import {isShown as isCreateUserPanelOpen} from '../panels/user/createPanel/selectors'
import {isPanelOpened as isCreateTeamAssignmentPanelOpen} from '../panels/user/createTeamAssignmentsPanel/selectors'
import {isShown as isCreateManagementAssignmentPanelOpen} from '../administration/userManagement/createManagementAssignmentsPanel/selectors'
import {showEditor as isCreateManagementAssignmentEditorOpen} from '../administration/userManagement/createUserManagementAssignmentsEditor/selectors'
import {isPanelOpened as isEditUserPanelOpen} from '../panels/user/editPanel/selectors'
import {isPanelOpened as isEditTeamAssignmentPanelOpen} from '../panels/user/editTeamAssignmentsPanel/selectors'
import {isPanelOpened as isEditManagementAssignmentsPanelOpen} from '../administration/userManagement/editManagementAssignmentsPanel/selectors'
import {showEditor as isEditManagementAssignmentsEditorOpen} from '../administration/userManagement/managementAssignmentsEditor/selectors'
import {isShown as isWorkAssignmentPanelOpen} from '../administration/userManagement/workAssignmentPanel/selectors'
import {showEditor as isWorkAssignmentEditorOpen} from '../administration/userManagement/workAssignmentsEditor/selectors'


export const isAnyUserListPanelOpen = createSelector(
    // from create user panel
    isCreateUserPanelOpen,
    isCreateTeamAssignmentPanelOpen,
    isCreateManagementAssignmentPanelOpen,
    isCreateManagementAssignmentEditorOpen,
    // from edit user panel
    isEditUserPanelOpen,
    isEditTeamAssignmentPanelOpen,
    isEditManagementAssignmentsPanelOpen,
    isEditManagementAssignmentsEditorOpen,
    // from user list (unique)
    isWorkAssignmentPanelOpen,
    isWorkAssignmentEditorOpen,
    (
        isCreateUserPanelOpen,
        isCreateTeamAssignmentPanelOpen,
        isCreateManagementAssignmentPanelOpen,
        isCreateManagementAssignmentEditorOpen,
        isEditUserPanelOpen,
        isEditTeamAssignmentPanelOpen,
        isEditManagementAssignmentsPanelOpen,
        isManagementAssignmentsEditorOpen,
        isWorkAssignmentPanelOpen,
        isWorkAssignmentEditorOpen,
    ) =>
        isCreateUserPanelOpen ||
        isCreateTeamAssignmentPanelOpen ||
        isCreateManagementAssignmentPanelOpen ||
        isCreateManagementAssignmentEditorOpen ||
        isEditUserPanelOpen ||
        isEditTeamAssignmentPanelOpen ||
        isEditManagementAssignmentsPanelOpen ||
        isManagementAssignmentsEditorOpen ||
        isWorkAssignmentPanelOpen ||
        isWorkAssignmentEditorOpen
)



// WEBPACK FOOTER //
// ./web/js/tips/selectors.js